import React from "react";

const LOGOS_URL =
    "https://customer-assets.emergentagent.com/job_7f71f558-edcb-44b5-8046-25f961da23c5/artifacts/2plnj3qc_loho2.png";

export default function Recruiters() {
    return (
        <section
            data-testid="recruiters-section"
            className="relative py-24 md:py-32"
            style={{ background: "#f8fafc" }}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="text-center max-w-3xl mx-auto mb-6 sm:mb-8 md:mb-10">
                    <p className="text-[11px] tracking-[0.22em] uppercase font-semibold mb-3" style={{ color: "#2e326b" }}>
                        Industry Trust
                    </p>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight tracking-tight" style={{ color: "#0f172a" }}>
                        Companies Where Our Students Thrive
                    </h2>
                    <div className="mt-4 h-[3px] w-16 mx-auto" style={{ background: "#ffc004" }} />
                </div>

                <div className="relative max-w-5xl mx-auto" data-testid="recruiters-grid">
                    <img
                        src={LOGOS_URL}
                        alt="Companies Where Our Students Thrive — Hiranandani, ICICI Bank, Runwal, Colliers, Epsilon Money, Axis Finance, Reliance Infrastructure, Sila"
                        className="w-full h-auto object-contain mix-blend-multiply"
                    />
                </div>
            </div>
        </section>
    );
}
